export default __webpack_public_path__ + "static/media/nairagramLogo.f6eac4c1.gif";